import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ListEmpty from '../../components/fragments/ListEmpty';
import Screen from '../../components/fragments/Screen';
import KanisaActionCard from '../../components/legacy/KanisaActionCard';
import { rtGetListData } from '../../store/slices/listSlice';

// import { events } from "../store/local/contents";

export default function ServiceScreen() {
    const dispatch = useDispatch();
    const state = useSelector((st) => st);
    const { services, busy } = state.list2;

    useEffect(() => {
        dispatch(rtGetListData('services', 'services'));
    }, [dispatch]);

    return (
        <Screen loading={busy['services']} title="Services">
            {services?.map(({ id, name, venue, date, time, remaining }) => (
                <KanisaActionCard
                    key={`${id}`}
                    name={name}
                    venue={venue}
                    date={date}
                    time={time.start}
                    num={remaining}
                    link={`service/${id}`}
                    service
                />
            ))}
            {!busy['services'] && services?.length < 1 && <ListEmpty />}
        </Screen>
    );
}
